import BecoMovieLogAccessDTO from 'models/becoMovie/BecoMovieLogAccessDTO';
import BecoMovieRelatorioParams from 'models/becoMovie/BecoMovieRelatorioParams';
import BecoMovieTipoAcessibilidadeDTO from 'models/becoMovie/BecoMovieTipoAcessibilidadeDTO';
import { GenericService } from './Generic.service';

export class BecoMovieService extends GenericService {
    readonly URI: string = '/v1/beco-movie';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public logAccess(body: BecoMovieLogAccessDTO) {
        return this.post('log-access', body);
    }

    public async getTipoAcessibilidade(): Promise<BecoMovieTipoAcessibilidadeDTO> {
        const { data } = await this.get('tipo-acessibilidade');
        return data;
    }

    public getRelatorioAcessos(params: BecoMovieRelatorioParams) {
        return this.getBlob('relatorio', params);
    }
}
